import React, {Component} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import './SelfStudyBookCard.css';
import IconContainer from '../../commonComponents/iconContainer/IconContainer';
import {Row, Col} from 'reactstrap';
import moment from 'moment';

class SelfStudyBookCard extends Component {
    render() {
        if (!_.isNil(this.props.data)) {
            return (
                <div className="self-study-book-card-container">
                    <IconContainer className="self-study-book-card-icon" icon="book"/>
                    {this.renderContent()}
                </div>
            );
        } else {
            return null;
        }
    }

    renderContent = () => {
        return (
            <div className="self-study-book-card-information-container">
                <div className="self-study-book-card-title">
                    <h6>{this.props.data.title}</h6>
                </div>
                <Row>
                    <Col sm={3}>
                        {_.get(this.props.translation, "self_study.domain_label") + ":"}
                    </Col>
                    <Col sm={9}>
                        {_.get(this.props.translation, "self_study.domains." + this.props.data.domain)}
                    </Col>
                </Row>
                <Row>
                    <Col sm={3}>
                        {_.get(this.props.translation, "self_study.publisher_label") + ":"}
                    </Col>
                    <Col sm={9}>
                        {this.props.data.publisher}
                    </Col>
                </Row>
                {
                    _.isNil(this.props.data.isbn) ? null :
                    <Row>
                        <Col sm={3}>
                            {_.get(this.props.translation, "self_study.isbn_label") + ":"}
                        </Col>
                        <Col sm={9}>
                            {this.props.data.isbn}
                        </Col>
                    </Row>
                }
                <Row>
                    <Col sm={3}>
                        {_.get(this.props.translation, "self_study.study_date_label") + ":"}
                    </Col>
                    <Col sm={9}>
                        {moment(this.props.data.studyDate).format('LL')}
                    </Col>
                </Row>
            </div>
        )
    };
}

SelfStudyBookCard.propTypes = {
    data: PropTypes.object,
    translation: PropTypes.object.isRequired,
};

export default SelfStudyBookCard;



// WEBPACK FOOTER //
// ./src/components/organizationConsentManagement/selfStudyBookCard/SelfStudyBookCard.js